
import { combineReducers } from 'redux';

import auth from '../common/client/reducers/auth';
import operationStatus from '../common/client/reducers/operationStatus';

import app from './app/';

export function getApp(state) {
    return state.app;
}

export default combineReducers({
    auth,
    operationStatus,

    app
});
